import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import cn from 'classnames';
import { Typography, useIntentBehavior } from 'seagull';
import { fullName } from '~/infra/utils';
import { selectors } from '~/store/state-selectors';
import { useStore } from '~/store/store-context';
import styles from './MobileSign.module.scss';
import { SignatureWithProgress } from './SignatureWithProgress';
import { SignSlider } from './SignSlider';
export function MobileSign(param) {
    let { relationship, disabled = false, intent, onSign, hideSignatoryTypography = false } = param;
    const [percent, setPercent] = useState(0);
    const { getDisabled } = useIntentBehavior();
    const userFirstName = useStore(selectors.user.firstName) || null;
    const userLastName = useStore(selectors.user.lastName) || null;
    const disabledFromIntent = intent ? getDisabled(intent) : false;
    const isDisabled = disabledFromIntent || disabled;
    const typographyProps = isDisabled ? {
        skin: 'invertedStandard',
        className: styles.hint
    } : {
        className: cn(styles.hint, styles.enabled)
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.root,
        children: [
            !hideSignatoryTypography && !disabled && /*#__PURE__*/ _jsx(SignatureWithProgress, {
                percent: percent,
                children: fullName(userFirstName, userLastName)
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: styles.slider,
                children: [
                    /*#__PURE__*/ _jsx(SignSlider, {
                        disabled: isDisabled,
                        onChange: setPercent,
                        onSign: onSign
                    }),
                    /*#__PURE__*/ _jsx(Typography, _object_spread_props(_object_spread({}, typographyProps), {
                        style: {
                            opacity: Math.max(1 - 6 * percent, 0)
                        },
                        children: relationship.isSample ? 'Approve test agreement' : 'Swipe to approve agreement'
                    }))
                ]
            })
        ]
    });
}
